/* eslint-disable no-unused-vars */
import React from "react";
import {
  TextField,
  Typography,
  FormControl,
} from "@mui/material";
import InputMask from "@mona-health/react-input-mask";
import "./styles.scss";


export default function MaskedInput(props) {
  const {
    name,
    value,
    label,
    required,
    placeholder,
    variant = "outlined",
    error = null,
    size = "small",
    fullWidth,
    type = "",
    onChange,
    onBlur,
    inlineMask,
    maskformat,
    disabled,
    ...others
  } = props;

  return (
    <FormControl
      variant={variant}
      className="formControl"
      {...(error && { error: true })}
    >
      <div className={inlineMask ? "inline-masked" : ""}>
        {label && (
          <Typography
            component="p"
            className={required ? "inputLabel required" : "inputLabel"}
          >
            {label}
          </Typography>
        )}
        <InputMask
          name={name}
          mask={value ? maskformat : null}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          maskChar={null}
          disabled={Boolean(disabled)}
          className="masked-input-container"
        >
          <TextField
            placeholder={placeholder}
            name={name}
            type={type}
            size={size}
            fullWidth={fullWidth ?? false}
            value={value}
            className="MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputMarginDense MuiInputBase-inputSizeSmall"
            {...others}
            error={!!error}
            helperText={error}
            InputProps={{
              classes: {
                input: 'masked-input'
              }
            }}
          />

        </InputMask>

        {/* <FormHelperText>{error && error}</FormHelperText> */}
      </div>
    </FormControl>
  );
}